// jquery function to get URL params
$.urlParam = function(name){
    var results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (!results) {
      return 0; 
    }
    return results[1] || 0;
}

// jquery function to count characters
$.fn.extend( {
  limiter: function(limit, elem) {
    $(this).on("keyup focus", function() {
      setCount(this, elem);
    });
    function setCount(src, elem) {
      var chars = src.value.length;
      if (chars > limit) {
        src.value = src.value.substr(0, limit);
        chars = limit;
      }
      elem.html( limit - chars );
    }
    setCount($(this)[0], elem);
  }
});

// jquery function to count classroom names
$.fn.extend( {
  nameCount: function(limit, elem) {
    $(this).on("keyup focus", function() {
      countNames(this, limit, elem);
    });
    function countNames(src, limit, elem) {
      var names = $(src).val().split(',').filter(function(v){return v!==''});;
      var nameCount = names.length;
      var qualifier = '';
      // TODO: Put together the output required
      if (nameCount > limit) {
        qualifier = " student certificates. Additional certificates are $2.00 each."
      } else {
        qualifier = " student certificates."
      }
      var count = nameCount+"/"+limit+qualifier;
      elem.html( count );
    }
    countNames($(this)[0], limit, elem);
  }
});

// override jquery validate plugin defaults
$.validator.setDefaults({
    highlight: function(element) {
        $(element).closest('.form-group').addClass('has-error');
    },
    unhighlight: function(element) {
        $(element).closest('.form-group').removeClass('has-error');
    },
    errorElement: 'span',
    errorClass: 'help-block',
    errorPlacement: function(error, element) {}
});

// override the Shopify option_selector
Shopify.OptionSelectors.prototype.buildSelectors = function() {
  // build selectors
  for (var i = 0; i < this.product.optionNames().length; i++) {
    var sel = new Shopify.SingleOptionSelector(this, i, this.product.optionNames()[i], this.product.optionValues(i));
    sel.element.disabled = false;
    this.selectors.push(sel);
  }

  // replace existing selector with new selectors, new hidden input field, new hidden messageElement
  var divClass = this.selectorDivClass;
  var optionNames = this.product.optionNames();
  var elements = Shopify.map(this.selectors, function(selector) {

    var wrap = document.createElement('div');
    wrap.setAttribute('class', 'form-group');
    var div = document.createElement('div');
    div.setAttribute('class', 'col-sm-10 col-md-10');
    // create label if more than 1 option (ie: more than one drop down)
    if (optionNames.length > 1) {
      // create and appened a label into div
      var label = document.createElement('label');
      label.setAttribute('class', 'sr-only');
      label.htmlFor = selector.element.id;
      label.innerHTML = selector.name;
      div.appendChild(label);
    }
    div.appendChild(selector.element);
    wrap.appendChild(div);
    return wrap;
  });

  return elements;
};

// override Shopify select builder
Shopify.SingleOptionSelector = function(multiSelector, index, name, values) {
  this.multiSelector = multiSelector;
  this.values = values;
  this.index = index;
  this.name = name;
  this.element = document.createElement('select');
  for (var i = 0; i < values.length; i++) {
    var opt = document.createElement('option');
    opt.value = values[i];
    opt.innerHTML = values[i];
    this.element.appendChild(opt);
  }
  this.element.setAttribute('class', 'form-control single-option-selector');
  this.element.id = multiSelector.domIdPrefix + '-option-' + index;
  this.element.onchange = function() {
    multiSelector.updateSelectors(index);
  };

  return true;
};

// Has the site been visited lately?
var visited = Cookies.get('visited');

// Adoption related functions
Adoption = {
  checkEcoRecipient: function() {
    if ($("#send-to-recipient:checked").length && $("#eco-cb:checked").length <= 0) {
      return true;
    } else {
      return false;
    }
  },

  checkEcoEmail: function() {
    if ($("#eco-cb:checked").length > 0) {
      return true;
    } else {
      return false;
    }
  },

  evalEco: function() {
    if ($(this).find('option:selected').text().indexOf("Individual") >= 0) {
      $('#eco-adoption').slideDown();
    } else {
      $('#eco-adoption').slideUp();
      $('#eco-cb').prop('checked', false);
    }
  },

  setupCharCount: function() {
    if ($('#char-count').length) {
      $('#recipient-message').limiter(250, $('#char-count'));
    }
  },

  setupEcoPreview: function() {
    defaultSrc = $('#featured-image img').attr('src');
    defaultTitle = $('#featured-image a').attr('title');
    $('#eco-cb').change(function() {
      if ($(this).prop('checked')) {
        // Show the eco preview
        $('#featured-image img').attr("src", "//whalemuseum.org/cdn/shop/t/3/assets/EcoFriendlyPreview.jpg?v=121761522659986223741383082077");
        $('#featured-image img').attr("alt", "Eco Friendly Adoption");
        $('#featured-image a').attr("href", "//whalemuseum.org/cdn/shop/t/3/assets/EcoFriendlyPreview.jpg?v=121761522659986223741383082077");
        $('#featured-image a').attr("title", "Eco Friendly Adoption");
      } else {
        // Show the product photo
        $('#featured-image img').attr("src", defaultSrc);
        $('#featured-image img').attr("alt", defaultTitle);
        $('#featured-image a').attr("href", defaultSrc);
        $('#featured-image a').attr("title", defaultTitle);
      }
    });
  },

  setupValidation: function() {
    $("#add-item-form").validate();
    // Require a certificate name
    $("#certificate_name").rules("add", {
      required: true,
      minlength: 3
    });
    // Require contact info sent to recipient
    $('#recipient-name').rules("add", {
      required: Adoption.checkEcoRecipient,
      minlength: 3
    });
    $('#recipient-addr').rules("add", {
      required: Adoption.checkEcoRecipient,
      minlength: 5
    });
    $('#recipient-city').rules("add", {
      required: Adoption.checkEcoRecipient,
      minlength: 3
    });
    $('#recipient-state').rules("add", {
      required: Adoption.checkEcoRecipient,
      minlength:2,
      maxlength:5
    });
    $('#recipient-zip').rules("add", {
      required: Adoption.checkEcoRecipient,
      minlength: 5
    });
    $('#recipient-country').rules("add", {
      required: Adoption.checkEcoRecipient,
      minlength: 2
    });
    $('#recipient-email').rules("add", {
      required: Adoption.checkEcoEmail,
      email: true
    });
    $('#recipient-message').rules("add", {
      minlength: 3
    });
  },

  setupVariantSelect: function() {
    // Variant selection drop-down
    if ($('#eco-adoption').length) {
      $('#adoption-select').change(Adoption.evalEco);
    } 
  },

  setupWhaleSelect: function() {
    // Whale selection drop-down
    $('#whale-select').change(function() {
      $('#whale-image').css({
        "opacity" : 0.5
      });
      $('#whale-loader').css({
        "top": $('#whale-image').height()/2 - 24 + "px",
        "left": $('#whale-image').width()/2 - 4 + "px"
      }).show();
      $.ajax({
        type: 'get',
        url: "/products/" + $(this).find('option:selected').val() + ".js",
        dataType: 'json'
      }).done(function(product) {
        $('#whale-image').load(function() {
          $(this).css({"opacity" : 1.0});
          $('#whale-loader').hide();
          $('#whale-title').text(product.title);
          $('#whale-sex').text(product.type);
          $('#whale-age').text(parseInt((new Date).getFullYear()) - parseInt(product.vendor));
          $('#whale-description').html(product.description);
        }).attr('src', product.featured_image);
        $('#whale-image-link').attr('href', product.featured_image);
        $('#adoption-select').empty();
        $.each(product.variants, function(index, value) {
          $('#adoption-select').append('<option value="' + value.id + '">' + value.title + ' - ' + Shopify.formatMoney(value.price).replace(/\s+/g, '') + '</option>');
        });
        $('#adoption-select').off('change');
        if ($.inArray(product.title.split(" ")[0], eco_banned) == -1) {
          // Eco adoption allowed
          $('#adoption-select').change(Adoption.evalEco);
          $('#adoption-select').trigger('change');
        } else {
          // Eco adoption not allowed
          $('#eco-cb').attr('checked', false);
          $('#eco-adoption').slideUp();
          $('#adoption-select').off('change');
        }
      }).fail(function() {
        alert('Failed to update page, please try again.');
      });
    });
  },

  setupPackageSelect: function() {
    if ($.urlParam('package')) {
      selected_package = $.urlParam('package').toLowerCase();
      // if there is option with "selected_package" in the name, select it
      $('#adoption-select-option-0 option').each(function() {
        if ($(this).text().toLowerCase().indexOf(selected_package) > -1) {
          $(this).parent().val($(this).val());
          return false;
        }
      });
    }
  }
}

Cart = {
  setupDonation: function() {
    $('#checkout, #update-cart').click(function(e) {
      if ($('#donate').length && $('#donate').val() != '') {
        e.preventDefault();
        $.ajax({
          type: 'post',
          url: "/cart/add.js",
          data: 'quantity=' + parseInt($('#donate').val()) + '&id=' + $('#donate-id').val(),
          dataType: 'json'
        }).done(function(product) {
          if (e.target.id == 'update-cart') {
            document.location.href = '/cart';
          } else {
            document.location.href = '/checkout';
          }
        });
      }
    });
  },

  setupNote: function() {
    $('#add-order-note').click(function(e) {
      e.preventDefault();
      $('#order-note').slideToggle();
    });
  },

  setupReferer: function() {
    // Check to see if "other" is selected, and if so show the field and switch out the "name" attr.
    $('select#referer').change(function(e){
      if ($(this).val() ==  'Other') {
        $('#referer_other_wrap').slideDown();
      } else {
        $('#referer_other').val('');
        $('#referer_other_wrap').slideUp();
      }
    });
  }
}

Contact = {
  setupValidation: function() {
    $('form.contact-form').validate();
    // Require a name
    $("#contact_name").rules("add", {
      required: true,
      minlength: 3
    });
    // Require an email
    $("#contact_email").rules("add", {
      required: true,
      email: true
    });
    // Require a body
    $("#contact_body").rules("add", {
      required: true,
      minlength: 10
    });
  }
}

Donation = {
  checkInHonorOf: function() {
    if ($("#memory-cb:checked")) {
      return true;
    } else {
      return false;
    }
  },

  checkRecipientRequired: function() {
    if ($("#memory-cb:checked").length && $("#send-notification-cb:checked").length) {
      return true;
    } else {
      return false;
    }
  },

  clearHonorFields: function() {
    // Clear "in honor of" fields
    $('#send-notification-cb').attr('checked', false);
    $('#recipient-name, #recipient-addr, #recipient-city, #recipient-state, #recipient-zip, #recipient-country, #recipient-phone, #recipient-message').val('');
    $('#honor-recipient').slideUp();
  },

  setupForm: function() {
    // Set up the "in honor of" checkbox
    if ($('#memory-cb').length) {
      // Memory checkbox
      $('#memory-cb').change(function() {
        if ($(this).is(':checked')) {
          $('#is-honor').slideDown();
        } else {
          $('#is-honor').slideUp();
          $('#honor-name').val('');
          Donation.clearHonorFields();
        }
      });
    }
    // Set up the send-notification-to cb
    if ($('#send-notification-cb').length) {
      // Send notification checkbox
      $('#send-notification-cb').change(function() {
        if ($(this).is(':checked')) {
          $('#honor-recipient').slideDown();
        } else {
          $('#honor-recipient').slideUp();
          Donation.clearHonorFields();
        }
      });
    }
    // Set up the notes
    $('#notes-link').click(function(e) {
      e.preventDefault();
      $('#notes-field').slideToggle();
    });
  },

  setupValidation: function() {
    $("#add-item-form").validate();
    // Require a donation amount
    $("#donation-amount").rules("add", {
      required: true,
      number: true
    });
    // Require "in honor of" name if 
    $('#honor-name').rules("add", {
      required: Donation.checkInHonorOf,
      minlength: 3
    });
    // Require contact info sent to recipient
    $('#recipient-name').rules("add", {
      required: Donation.checkRecipientRequired,
      minlength: 3
    });
    $('#recipient-addr').rules("add", {
      required: Donation.checkRecipientRequired,
      minlength: 5
    });
    $('#recipient-city').rules("add", {
      required: Donation.checkRecipientRequired,
      minlength: 3
    });
    $('#recipient-state').rules("add", {
      required: Donation.checkRecipientRequired,
      minlength:2,
      maxlength:5
    });
    $('#recipient-zip').rules("add", {
      required: Donation.checkRecipientRequired,
      minlength: 5
    });
    $('#recipient-country').rules("add", {
      required: Donation.checkRecipientRequired,
      minlength: 2
    });
    $('#recipient-message').rules("add", {
      minlength: 3
    });
  }
}

map = {
  base_height: null,
  center: null,
  map: null,

  init: function() {
    // toggle map size
    $('.toggle-map-size').click(function(e) {
      e.preventDefault();
      map.toggleMapSize();
    });

    map.center = new google.maps.LatLng(48.535761, -123.017193);
    options = {
      center: map.center,
      zoom: 16,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    }
    map.map = new google.maps.Map(document.getElementById("map"), options);
    infoContent = "<address>"+
                  "<p>"+
                  "<strong>The Whale Museum</strong><br>"+
                  "62 1st St<br>"+
                  "Friday Harbor, WA<br>"+
                  "98250"+
                  "</p>"+
                  "<p>"+
                  "<abbr title=\"Phone\">p:</abbr> (360) 378-4710<br>"+
                  "<abbr title=\"Email\">e:</abbr> "+
                  "<a href=\"mailto:info@whalemuseum.org\">info@whalemuseum.org</a>"+
                  "</p>"+
                  "</address>";
    infoWindow = new google.maps.InfoWindow({
      content: infoContent
    });
    marker = new google.maps.Marker({
      position: map.center,
      map: map.map,
      title:"The Whale Museum",
      animation: google.maps.Animation.DROP
    });
    google.maps.event.addListener(marker, 'click', function() {
      infoWindow.open(map.map,marker);
    });
  },

  toggleMapSize: function() {
    current_height = parseInt($('#map').css('height'));
    if (current_height == map.base_height) {
      new_height = (parseInt($(window).height()) - 200)+'px';
    } else {
      new_height = map.base_height+'px';
    }
    $('#map').animate({height: new_height}, 500, function() {
      google.maps.event.trigger(map.map, 'resize');
      map.map.setCenter(map.center);
    });
  }
}

Meet = {
  fadedOpacity: 0.75,
  initialHeight: 0,

  // TODO: Remove these after page changeover
  setupForm: function() {
    $( "#meet-form" ).submit(function(e) {
      e.preventDefault();
    });
    // text field
    $('#meet-name').keyup(Meet.updatePage);
    // dropdowns
    $('#meet-pod, #meet-sex, #meet-age').change(Meet.updatePage);
  },

  updatePage: function() {
    // update the page based on the selections.
    if (($('#meet-name').val() == '') && ($('#meet-pod').val() == 'all') && ($('#meet-sex').val() == 'any') && ($('#meet-age').val() == 'any')) {
      $('.meet-item').show();
    } else {
      $('.meet-item').hide();
      el = "";
      if ($('#meet-name').val() != '') {
        el += '[data-name*="' + $('#meet-name').val().toLowerCase() + '"]';
      }
      if ($('#meet-pod').val() != 'all') {
        el += '[data-pod="' + $('#meet-pod').val() + '"]';
      }
      if ($('#meet-sex').val() != 'any') {
        el += '[data-sex="' + $('#meet-sex').val() + '"]';
      }
      if ($('#meet-age').val() != 'any') {
        min = parseInt($('#meet-age').val().split('-')[0]);
        max = parseInt($('#meet-age').val().split('-')[1]);
        if (max == "") { max = 150 }
        range = [];
        while (min <= max) {
          range.push(el + '[data-age="' + min++ + '"]');
        }
        el = range.join(", ");
      }
      $(el).show();
    }
  },
  // end remove

  setupWhaleSearch: function() {
    // Change opacity on hover
    $('#whale-viewer .whale-item a img').hover(function() {
      if (parseFloat($(this).css('opacity')) > 0.7) {
        $(this).css('opacity', 1);
      }
    }, function() {
      if (parseFloat($(this).css('opacity')) > 0.7) {
        $(this).css('opacity', Meet.fadedOpacity);
      }
    });

    // Reset the whale search
    $('.whale-search-clear').click(function(e){
      e.preventDefault();
      $('#reset-search-link').hide();
      $('#whale-name').val('');
      // sex radios
      $('.sex-select-menu label.active').removeClass('active');
      $('.sex-select-menu label:first-child').addClass('active');
      // pod checkboxes
      $('.pod-select-menu label.active').removeClass('active');
      // age select
      $('#whale-age').val('any');
      $('#whale-viewer .whale-item a img').css('opacity', Meet.fadedOpacity);
      $('#whale-viewer #no-results').hide();
      $.fancybox.close();
      $('#whale-viewer').animate({height: Meet.initialHeight+'px'}, 500);
    });

    // Submit the search form
    $('#whale-search-form').submit(function(e) {
      e.preventDefault();
      $('#whale-viewer #no-results').hide();
      // If none selected, go back to normal...
      if ($('#whale-name').val() == '' && $('.sex-select-menu label.active input ').val() == 'any' && $('.pod-select-menu label.active').length == 0 && $('#whale-age').val() == 'any') {
        $('.whale-item a img').css('opacity', Meet.fadedOpacity);
      } else {
        selector = ''
        $('.whale-item a img').css('opacity', 0.2);
        // Check the name
        if ($('#whale-name').val() != '') {
          selector += '[data-name*="' + $('#whale-name').val().toLowerCase() + '"]';
        }
        // Check the sex
        if ($('.sex-select-menu label.active input').val() != 'any') {
          selector += '[data-sex="' + $('.sex-select-menu label.active input').val() + '"]';
        }
        // Check the pods
        if ($('.pod-select-menu label.active').length > 0) {
          pods = [];
          $('.pod-select-menu label.active').each(function() {
            // add the value to the selectors
            pods.push(selector + '[data-pod="' + $(this).find('input').val() + '"]');
          });
          selector = pods.join(', ');
        }
        // Check the age range
        if ($('#whale-age').val() != 'any') {
          min = $('#whale-age').val().split('-')[0];
          max = $('#whale-age').val().split('-')[1];
          if (max == "") { max = 150 }
          ages = [];
          split_selector = selector.split(', ');
          $.each(split_selector,function(index, element) {
            while (min <= max) {
              ages.push(element + '[data-age="' + min++ + '"]');
            }
            min = $('#whale-age').val().split('-')[0];
          });
          selector = ages.join(", ");
        }
        // split up the selector to add CSS suffixes (a img)
        selector_array = selector.split(', ');
        new_selector = []
        $.each(selector_array, function(index, element) {
          new_selector.push(element + " a img");
        });
        final_selector = new_selector.join(', ');
        // Set results brighter
        $(final_selector).css('opacity', Meet.fadedOpacity);
        // If no results, show feedback.
        if ($(final_selector).length == 0) {
          $('#whale-viewer #no-results').fadeIn();
        }
        // If only one result, open the fancybox
        if ($(final_selector).length == 1) {
          setTimeout(function() { 
            $.fancybox.open($(final_selector).parent().attr('href'));
          }, 300);
        }
        $('#reset-search-link').show();
      }
      // Make the viewer larger if not already
      current_height = parseInt($('#whale-viewer').css('height'));
      if (current_height == Meet.initialHeight) {
        $('#whale-viewer').animate({height: parseInt($('#whale-inner').css('height'))+'px'}, 500);
      }
      // Close the search form
      $.fancybox.close();
    });
  },

  setupWhaleSelect: function() {
    $('.whale-select-menu').change(function() {
      if ($(this).val() != '') {
        window.location = $(this).val();
      }
    });
  },

  toggleViewerSize: function() {
    current_height = parseInt($('#whale-viewer').css('height'));
    if (current_height == Meet.initialHeight) {
      // Expand map
      new_height = parseInt($('#whale-inner').css('height'))+'px';
    } else {
      new_height = Meet.initialHeight+'px';
    }
    $('#whale-viewer').animate({height: new_height}, 500);
  }
}

Membership = {
  checkGift: function() {
    if ($("#gift-cb:checked").length) {
      return true;
    } else {
      return false;
    }
  },

  checkRecipient: function() {
    if ($("#send-to-recipient:checked").length) {
      return true;
    } else {
      return false;
    }
  },

  setupValidation: function() {
    $("#add-item-form").validate();
    // Require contact info sent to recipient
    $('#recipient-name').rules("add", {
      required: Membership.checkGift,
      minlength: 3
    });
    $('#recipient-addr').rules("add", {
      required: Membership.checkRecipient,
      minlength: 5
    });
    $('#recipient-city').rules("add", {
      required: Membership.checkRecipient,
      minlength: 3
    });
    $('#recipient-state').rules("add", {
      required: Membership.checkRecipient,
      minlength:2,
      maxlength:5
    });
    $('#recipient-zip').rules("add", {
      required: Membership.checkRecipient,
      minlength: 5
    });
    $('#recipient-country').rules("add", {
      required: Membership.checkRecipient,
      minlength: 2
    });
    $('#recipient-email').rules("add", {
      email: true
    });
  }
}

Product = {
  clearRecipientFields: function() {
    $('#recipient-name, #recipient-addr, #recipient-city, #recipient-state, #recipient-zip, #recipient-country, #recipient-email, #recipient-phone').val('');
  },

  giftRecipient: function() {
    // look for gift cb
    if ($('#gift-cb').length) {
      // Gift checkbox
      $('#gift-cb').change(function() {
        if ($(this).is(':checked')) {
          $('#is-gift').slideDown();
        } else {
          $('#is-gift').slideUp();
          Product.clearRecipientFields();
          $('#send-to-me').prop('checked', true);
          $('#send-to-recipient').prop('checked', false);
        }
      });
    }
  }
}

Seasound = {
  base_height: null,
  latlngbounds: null,
  map: null,

  showMap: function() {
    // toggle map size
    $('.toggle-map-size').click(function(e) {
      e.preventDefault();
      Seasound.toggleMapSize();
    });

    // Map options
    map_options = {
      center: new google.maps.LatLng(48.316081,-123.607178),
      zoom: 7,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    }

    // Marker positions
    lk_pos = new google.maps.LatLng(48.515837,-123.152747);
    nb_pos = new google.maps.LatLng(48.372558,-124.593458);
    os_pos = new google.maps.LatLng(48.558773,-123.17369);
    pt_pos = new google.maps.LatLng(48.135736,-122.760372);
    sl_pos = new google.maps.LatLng(47.607349,-122.343621);

    // Marker titles
    lk_title = "Lime Kilm Point";
    nb_title = "Neah Bay";
    os_title = "Orcasound";
    pt_title = "Port Townsend Marine Science Center";
    sl_title = "Seattle Aquarium";

    // Marker infos
    lk_info = "<h3 style=\"margin-top:0;\">Lime Kiln Point</h3>"+
              "<p>We've got two hydrophones at ~8m<br>"+
              "depth just outside the kelp next to<br>"+
              "the lighthouse at Lime Kiln State Park.</p>"+
              "<p>"+
              "<a href=\"http://orcasound.net/lk/?gmapnb\">"+
              "Learn More</a><br>"+
              "<a href=\"https://mcp.stream101.com/start/smrucons/\">"+
              "Listen Live</a></p>";
    nb_info = "<h3 style=\"margin-top:0;\">Neah Bay</h3>"+
              "<p>There are two hydrophones under<br>"+
              "a pier near the mouth of Neah Bay.</p>"+
              "<p>"+
              "<a href=\"http://orcasound.net/nb/?gmapnb\">"+
              "Learn More</a><br>"+
              "<a href=\"http://sc3.spacialnet.com:23696/listen.pls\">"+
              "Listen Live</a></p>";
    os_info = "<h3 style=\"margin-top:0;\">Orcasound</h3>"+
              "<p>There are two hydrophones 25m<br>"+
              "offshore at depths of 8 to 15 meters.</p>"+
              "<p>"+
              "<a href=\"http://orcasound.net/os/?gmapos\">"+
              "Learn More</a><br>"+
              "<a href=\"http://sc6.spacialnet.com:17636/listen.pls\">"+
              "Listen Live</a></p>";
    pt_info = "<h3 style=\"margin-top:0;\">Port Townsend</h3>"+
              "<p>There are two hydrophones at ~6m<br>"+
              "depth and 10m apart under the outer<br>"+
              "pier at the Marine Science Center.</p>"+
              "<p>"+
              "<a href=\"http://orcasound.net/pt/?gmapnb\">"+
              "Learn More</a><br>"+
              "<a href=\"http://sc3.spacialnet.com:16948/listen.pls\">"+
              "Listen Live</a></p>";
    sl_info = "<h3 style=\"margin-top:0;\">Seattle Aquarium</h3>"+
              "<p>There are two hydrophones at ~8m<br>"+
              "depth just outside the kelp next to<br>"+
              "the lighthouse.</p>"+
              "<p>"+
              "<a href=\"http://orcasound.net/sa/?gmapnb\">"+
              "Learn More</a><br>"+
              "<a href=\"http://sc3.spacialnet.com:16902/listen.pls\">"+
              "Listen Live</a></p>";

    // Render the map
    Seasound.map = new google.maps.Map(document.getElementById("map"), map_options);

    // Bounds object
    Seasound.latlngbounds = new google.maps.LatLngBounds();

    // Create an infowindow
    infowindow = new google.maps.InfoWindow({
      content: ""
    });

    // Loop through each position and create a marker
    //markers = ["lk", "nb", "os", "pt", "sl"];
    markers = ["lk"];
    markers.forEach(function(elem, index, array) {
      // extend the bounds
      Seasound.latlngbounds.extend(eval(elem+'_pos'));

      // create a marker
      marker = new google.maps.Marker({
        position: eval(elem+'_pos'),
        map: Seasound.map,
        title: eval(elem+'_title'),
        animation: google.maps.Animation.DROP
      });
      // add listener to marker
      google.maps.event.addListener(marker, 'click', function() {
        infowindow.setContent(eval(elem+'_info'));
        infowindow.open(Seasound.map, this);
      });
    });

    // Auto fit
    //Seasound.map.fitBounds(Seasound.latlngbounds);
  },

  toggleMapSize: function() {
    current_height = parseInt($('#map').css('height'));
    if (current_height == Seasound.base_height) {
      new_height = (parseInt($(window).height()) - 200)+'px';
    } else {
      new_height = Seasound.base_height+'px';
    }
    $('#map').animate({height: new_height}, 500, function() {
      google.maps.event.trigger(Seasound.map, 'resize');
      //Seasound.map.fitBounds(Seasound.latlngbounds);
    });
  }
}

Signup = {
  setupValidation: function() {
    $("#signup-form").validate();
    // Require a certificate name
    $("#signup-email").rules("add", {
      required: true,
      email: true
    });
  }
}

// DOM is loaded
$(document).ready(function() {
  // Placeholder shim
  $('input, textarea').placeholder();

  // Set up the external links
  $("a[rel^='external']").each(function() {
    $(this).attr('target', '_blank');
  });

  // Set up carousel
  if ($('#wm-carousel').length) {
    $('#wm-carousel').carousel({
      interval: 7000
    });
  }

  // Set up FancyBox
  $('.fancybox').fancybox({
    helpers: {
      overlay: {
        opacity: 0.9
      }
    }
  });
  
  // Set up popovers
  $('[data-toggle="popover"]').click(function(e) {
    e.preventDefault();
  });
  $('body').popover({
    selector: '[data-toggle="popover"]',
    trigger: 'hover'
  });

  // Signup form setup
  if ($('#signup-form').length) {
    Signup.setupValidation();
  }

  // Product page setup
  Product.giftRecipient();

  // Set up the adoption page
  if ($("#adoption").length) {
    Adoption.setupCharCount();
    Adoption.setupEcoPreview();
    Adoption.setupVariantSelect();
    Adoption.setupWhaleSelect();
    Adoption.setupPackageSelect();
    Adoption.setupValidation();
  }

  // Set up the cart page
  if ($("#cart").length) {
    Cart.setupDonation();
    Cart.setupNote();
    Cart.setupReferer();
  }

  // Set up the contact page
  if ($("#contact").length) {
    Contact.setupValidation();
    $('#contact_body').elastic();
  }

  // Set up the donation page
  if ($("#donation").length) {
    Donation.setupForm();
    Donation.setupValidation();
  }

  // Set up the map
  if ($("#finding-us").length) {
    map.base_height = parseInt($('#map').css('height'));
    map.init();
  }

  // Set up Seasound map
  if ($("#seasound").length) {
    Seasound.base_height = parseInt($('#map').css('height'));
    Seasound.showMap();
  }

  // Set up the membership page
  if ($("#membership").length) {
    Membership.setupValidation();
  }

  // Set up the meet the whales page
  // TODO: Remove this
  if ($("#meet-the-whales").length) {
    Meet.setupForm();
  }

  if ($("#whale-viewer").length) {
    Meet.initialHeight = parseInt($('#whale-viewer').css('height'));
    $('.toggle-viewer-size').click(function(e) {
      e.preventDefault();
      Meet.toggleViewerSize();
    });
    Meet.setupWhaleSearch();
    Meet.setupWhaleSelect();
    $('#whale-search-link').trigger('click');
  }

  // Set up the search link
  if ($("#search-link").length) {
    $("#search-link").click(function() {
      $("#search-bar").slideToggle();
    });
  }
});

// Images are loaded
$(window).load(function() {
  // Fade in the whale images
  if ($('#whale-viewer').length) {
    $('#whale-viewer .whale-item a img').css('opacity', Meet.fadedOpacity);
    $('#whale-search-link').trigger('click');
    Meet.toggleViewerSize();
  }

  // Set up masonry
  if ($('#products').length) {
    $('#products').masonry({
      itemSelector: '.item'
    });
  }

  
});
